import classes from "./primaryButton.module.css";
import React, { ButtonHTMLAttributes } from "react";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "light" | "dark" | "active";
  size?: "normal" | "small";
  leftIconUrl?: string;
  fullWidth?: boolean;
}

const PrimaryButton = (props: IProps) => {
  const {
    variant = "active",
    size = "normal",
    fullWidth = false,
    leftIconUrl,
    children,
    ...buttonProps
  } = props;

  const classNames = [
    classes.btn,
    classes[variant],
    classes[size],
  ];

  if (fullWidth) {
    classNames.push(classes.fullWidth);
  }

  if (!children) {
    classNames.push(classes.withoutChildren);
  }

  return (
    <button className={classNames.join(" ")} {...buttonProps}>
      <div className={classes.background}>
        <div className={classes.wrapper}>
          { leftIconUrl && (
            <img className={classes.icon} src={leftIconUrl} alt=""/>
          )}
          {
            children && (<div>{ children }</div>)
          }
        </div>
      </div>
    </button>
  );
};

export default PrimaryButton;
